/* eslint-disable */
// content inline. Vanuit sitecore zou echter ideaal zijn
const cookieMessageVideoTitle = "Let op";
const cookieMessageVideoBody = "Je kunt momenteel geen video\'s bekijken, omdat je hiervoor geen cookies hebt geaccepteerd. Wil je toch video\'s bekijken? Wijzig dan je cookie instellingen.";
const cookieMessageVideoCTA = '<a href="#" onclick="_stCookiePopup.showSettings(); return false;" class="button button--outline" data-meetid="ipoclick-lnk-[[paza]]-footer-cookie-instellingen">Instellingen aanpassen</a>';

window.getCookieMessageVideoTitle = (function() {
  return cookieMessageVideoTitle;
})
window.getCookieMessageVideoBody = (function() {
  return cookieMessageVideoBody;
});
window.getCookieMessageVideoCTA = (function() {
  return cookieMessageVideoCTA;
});

window.getCookieLevel = (function() {
  var ca = decodeURIComponent(document.cookie).split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf('_svs=') == 0) {
      var cc = JSON.parse(c.substring(5, c.length))['c'];
      switch (true) {
        case (cc[1]&&cc[2]&&cc[3]): 
          return 3;
        case (cc[1]&&cc[2]): 
          return 2;
        case cc[1]: 
          return 1;
        default:
          return 0;
      }
    }
  }
});
/* eslint-enable */

